import $ from 'jquery';
import delay from '@frontend/util/delay';
import { toKebabCase } from '@frontend/util/text';

const updateTabs = () => {
  $('.middle-nav-links .nav-item').each((i, element) => {
    element = $(element);
    const section = toKebabCase(element.text().trim());
    element.attr('data-section', section);
  });
};

const mobileSubNav = (mText) => {
  $('.mobile-sub-nav-text').text(mText.first().text());
  $('.sub-nav-list a').each((i, e) => {
    if ($(e).text() === mText.first().text()) {
      $(e).hide();
    }
  });
};

const initSubNav = () => {
  const currPth = window.location.pathname.split('.')[0];
  $('.sub-navigation a').removeClass('active');
  if (currPth.indexOf('/knowledge/') > -1) {
    $('.sub-navigation a[href*="/knowledge/"]').each((i, e) => {
      $(e).addClass('active');
    });
  } else if (currPth.indexOf('/solutions/') > -1) {
    $('.sub-navigation a[href*="/solutions"]').each((ix, el) => {
      $(el).addClass('active');
    });
  } else {
    const activeSub = $('.sub-navigation a').filter((a, b) => b.href.indexOf(currPth) > -1);
    if (activeSub.length > 1) {
      $('.sub-navigation a').first().addClass('active');
    } else {
      $(activeSub).addClass('active');
    }
  }
  const mText = $('.sub-navigation a.active');
  // eslint-disable-next-line no-unused-expressions
  mText.length ? mobileSubNav(mText) : $('.mobile-sub-nav-text').text('Select');
};

export default () => {
  updateTabs();
  initSubNav();

  $('.global-nav-toggle').on('click', (evt) => {
    evt.stopPropagation();
    const $nav = $('.global-nav-menu');

    if ($nav.hasClass('open')) {
      $nav.removeClass('open');
      $('body').removeClass('nav-open');
    } else {
      $nav.addClass('open');
      delay(250).then(() => $('body').addClass('nav-open'));
    }
  });

  let closable = false;
  const menuOverlay = '<div class="menu-overlay"></div>';

  $('.menu-overlay-link .menu-trigger').on('click', () => {
    closable = true;
  });

  $('.menu-overlay-link').on({
    'shown.bs.dropdown': () => {
      $('.cghb-body-content').append(menuOverlay);
      closable = false;
    },
    'hide.bs.dropdown': () => {
      if (closable) {
        $('.cghb-body-content .menu-overlay').remove();
      }
      return closable;
    }
  });

  $('.prevent-anchor').on('click', (evt) => {
    evt.preventDefault();
  });
};



// WEBPACK FOOTER //
// ./src/static/js/navigation.js